


const metrics = [
  {
    /**
     * This text will be shown on the "all metrics" page, on the card.
     */
    name: 'Bring back jobs lost in the pandemic',

    /**
     * This will be shown on the "all metrics" page, on the card, just above the "name".
     */
    topic: 'Recovery',

    /**
     * This text will be shown at the top of "metric" page, in very large colored text.
     */
    headerName: 'bring back the jobs we lost',


    /**
     * This will be in a sentence, just under the above header. The sentence format is 
     * -- We're putting forward {metric.policies.length} big policies that will {metric.impactSummary} over her first term.
     */
    impactSummary: 'will bring back 70% of the jobs lost through City Hall action alone',

    /**
     * This will be used in the chart beside each number.
     */
    policyUnit: 'jobs',

    /**
     * If true, we'll display a $ in front of numbers.
     */
    policyUnitIsCurrency: false,

    /**
     * Each entry here represents one bar in the chart. 
     */
    policies: [
      {
        name: 'Frontload spending on housing',
        chartName: 'housing',
        impact: 84000,
        description: 'Increasing construction spending on housing in a down cycle is a win-win. The City can create good construction jobs and affordable housing improves employment outcomes.'
      },
      {
        name: 'Kickstart infrastructure investment',
        chartName: 'infrastructure',
        impact: 19800,
        description: 'Investing in parks, green infrastructure, improved transportation, and healthcare clinics adds jobs and makes the City more livable.'
      },
      {
        name: 'Free childcare for working families',
        chartName: 'childcare',
        impact: 6900,
        description: 'Free childcare for those that need it helps parents re-enter the workforce and creates new childcare jobs.'
      },
      {
        name: 'Pathways for youth employment & career development',
        chartName: 'youth jobs',
        impact: 25200,
        description: 'Youth employment programs increase the likelihood of having a job by 70%. Giving young people the opportunity to gain job skills and earn a paycheck has positive impacts in their lives and in the larger economy.'
      },
      
      {
        name: 'Bring back small businesses',
        chartName: 'small business',
        impact: 318900,
        description: 'Small businesses are an important driver of employment in the city. Encouraging their recovery will increase employment both for entrepreneurs & their neighbors.'
      }
    ],
    
    underChartText: 'There are about 631k jobs missing due to the pandemic. These policies will bring back 72 percent of them and federal support and the COVID recovery will bring back the rest.',
    
    /**
     * Each entry under "details" is a paragraph with an optional header.
     */
      
    details: [
      {
        header: 'Frontload spending on housing',
        text: 'Every $200k of construction spending creates 1 jobs and in the first four years, Kathryn will spend $16.7 billion in federal, state and City funds to build deeply affordable housing, renovate NYCHA, and give a stable foundation for New Yorkers at-risk of homelessness. Providing housing increases employment by approximately 10 percentage points. Approximately 6800 apartments will be move-in ready at the end of the first term, with 680 new jobs created as a result.',
      },
      {
        header: 'Kickstart infrastructure investment',
        text: 'Kathryn’s plan to green schoolyards, decarbonize NYCHA, invest in our transit system, and build new healthcare clinics will create permanent jobs and construction jobs. Over four years, Kathryn will spend $3.9 billion using a combination of federal, state, and City funding to get our infrastructure working for New Yorkers.',        
      },
      {
        header: 'Free childcare for working families',
        text: 'Kathryn’s childcare plan will serve about 5,600 families earning less than $70k. Approximately 1.8 million households in New York City make less than $75,000 a year and ~25% of households have children with ~25% of households with kids having children under 3. Some of these families already use childcare but some will be new. Research says providing childcare increases labor force participation by 5 percentage points. Based on the number of parents eligible for free childcare, we estimate 5,625 (5%) parents that had not previously used childcare will use it and find employment. The number of employees required to operate a childcare center ranges on the age of the children under their supervision - requiring one staff member for every 4 or 5 children, creating 1,200 jobs.',        
      },
      {
        header: 'Pathways for youth employment & career development',
        text: 'Research into the historical effects of a New York City employment program found a 70% increase in the probability of having a job if offered a job (some students turn it down or do not stay at the job offered) and so planning for 10,000 interns translates into about 7,000 jobs. Kathryn’s City jobs guarantee is assumed to have the same effect. In addition, Kathryn’s plan to place career coordinators at every high school, subsidize wages for students with barriers to employment, and engaging employers in a partnership-based approach will serve about 4,000 students annually, with 16,000 students served over her first term. We apply the same 70% increase in probability of employment, with an expected increase of 11,200 jobs.',
      },
      {
        header: 'Bring back small businesses',
        text: '89 percent of businesses in New York City have fewer than 20 employees. Using an average of 10 jobs per small business, if Kathryn’s small business policies bring back and support the creation ~31,900 businesses, about 318,900 jobs are created too, excluding the jobs already attributable to childcare. Most childcare businesses are small businesses.',
      }
    ]
  },
  {
    name: 'Creating a livable City by converting street space for use by all New Yorkers',
    headerName: 'reclaim our streets from cars',
    sayInPlaceInsteadOfForward: true,
    impactSummary: 'increase street space for pedestrians, cyclists, and bus riders by taking on the 25 x 25 challenge set by Transportation Alternatives',
    topic: 'Transportation',
    policyUnit: 'square miles',
    policyUnitIsCurrency: false,
    policies: [
      {
        name: 'Make open streets permanent for culture, dining, community space, and recreation',
        chartName: 'open streets',
        impact: 3.5,
      },
      {
        name: 'Enable a massive shift to car-free transit - including expanded busways, bus-only lanes, protected bike lanes, and more bike parking',
        chartName: 'new transportation',
        impact: 2.7,
      },
      {
        name: 'Reserve space for curbside garbage pick-up, deliveries, and pick-ups',
        chartName: 'curbside space',
        impact: 3.1,
      },
      {
        name: 'Improve safety, sidewalks, subway entrances, and school zones',
        chartName: 'improvements',
        impact: 2.9,
      },
      {
        name: 'Experiment with policies to convert free parking spaces to metered parking',
        chartName: 'parking reform',
        impact: 5.0,
      },
    ],
    details: [
      {
        header: 'Executing ambitious plans',
        text: 'Transportation Alternatives and a coalition of advocates put forward a challenge to convert 25 percent of streets and sidewalk space from car uses to support the broader public by 2025. In order to accomplish this ambitious goal, we must move at breakneck speed to marshal the City’s resources behind this effort, streamline approvals, empower communities to experiment with short-term changes to their streetscape, and partner with local organizations and BIDs to manage spaces effectively. Big change demands the focus and commitment of City Hall and Kathryn will deliver.',
        footnoteLink: 'https://nyc25x25.org/#report'
      },
    ]
  },
  {
    name: 'Giving our students more resources',
    topic: 'Education',
    headerName: 'put education funding where it matters most - in classrooms',
    impactSummary: 'bring $280 million to students',
    policyUnit: 'million',
    policyUnitIsCurrency: true,
    policies: [
       {
        name: 'Guarantee a social worker at every school',
        chartName: 'social workers',
        impact: 90,
        description: 'Over 4,000 students have lost a parent to COVID-19 and students need support to cope with the trauma of the pandemic. Guaranteeing a social worker at every school will help students heal from COVID.'
      },
      {
        name: 'Support students experiencing homelessness',
        chartName: 'student homelessness',
        impact: 22,
        description: 'At 140 schools, more than 20% of students are experiencing homelessness. We will make sure schools offer services and stability for families and students and provide practical necessities.'
      },
      {
        name: 'Expand magnet offerings for every single elementary school',
        chartName: 'magnet programs',
        impact: 104,
        description: 'Every student and every school deserves advanced learning opportunities and academic enrichment like arts programming, sports, and music. We will expand magnet offerings to every school and make sure all students can access specialized programs.'
      },
      {
        name: 'Begin bilingual programs and offer language classes at every elementary school',
        chartName: 'bilingual programs',
        impact: 18,
        description: 'Our children need to be prepared for success in a global economy and a global city. We will make sure every elementary school has bilingual programming and quality English as a second language programs.'
      },
      {
        name: 'Build career pipelines at every high school and subsidize wages for students with barriers to employment',
        chartName: 'youth jobs',
        impact: 52,
        description: 'All high school students will have the opportunity to explore their career interests, make professional connections and mentors, and connect their academic education with on-the-job learning.'
      },
    ],
    underChartText: 'By the end of her first term, Kathryn will invest over a quarter of a billion dollars to help students recover emotionally and educationally from COVID losses',
    details: []
  },
  {
    name: 'Cutting homelessness in half with permanent solutions',
    topic: 'Housing',
    headerName: 'permanently drive down homelessness',
    impactSummary: 'cut homelessness by 48%',
    policyUnit: 'people',
    policyUnitIsCurrency: false,
    policies: [
      {
        name: 'Build 10k new supportive housing apartments',
        chartName: 'supportive housing',
        impact: 2000,
        description: 'New York City needs more apartments with support services to meet the needs of people at-risk of homelessness or who are currently experiencing homelessness.'
      },
      {
        name: 'Subsidize 50k new affordable apartments for residents most burdened by high rents',
        chartName: 'affordable apartments',
        impact: 8800,
        description: 'The solution to homelessness is housing. Focusing subsidies on new, deeply affordable housing will offer options for New Yorkers who would otherwise face homelessness.'
      },
      {
        name: 'Increase eligibility for the right to counsel',
        chartName: 'right to counsel',
        impact: 4300,
        description: 'Giving New Yorkers lawyers to fight evictions is a proven way to avoid evictions - a key to reducing homelessness.'
      },
      {
        name: 'Expand and simplify rental assistance programs',
        chartName: 'rental assistance',
        impact: 8200,
        description: 'Cutting rental assistance was the beginning of a major surge in homelessness in New York City. Preventing homelessness before it happens will make a major difference.'
      },
      {
        name: 'Raise the value of rental vouchers',
        chartName: 'vouchers',
        impact: 2750,
        description: 'Worthless vouchers are not useful. Raising the value will put many more apartments within reach of the thousands of New Yorkers living in homeless shelters with a voucher they struggle to use.'
      },
      {
        name: 'Legalize single-room occupancy (SRO) housing',
        chartName: 'SROs',
        impact: 175,
        description: 'SROs have historically been a source of cheap housing for single addults. Setting the table for more SRO development will have small impacts in the short-term wbut will be a good long-term step to increase housing supply.'
      },
    ],
    underChartText: 'About 55k New Yorkers are living on the streets or in homeless shelters. By taking sweeping action in the first term, we can cut that number nearly in half - the lowest number since October of 2001',
    details: [
      {
        header: 'Build 10k new supportive housing apartments',
        text: 'Financing 20% of the planned 10k new supportive housing apartments in the first year of a Garcia administration means that 2,500 residents will have brand-new apartments to move into during her fourth year. By creating new supporitve housing, we can move people out of shelter and into housing.',
      },
      {
        header: 'Subsidize 50k new affordable apartments for residents most burdened by high rents',
        text: 'Creating new apartments for the lowest-income New Yorkers (and the most severely rent-burdend) can prevent homelessness and provide a direct placement from a shelter. Financing 20% of the 50k new affordable housing units for New Yorkers making 30% of AMI in the first year of a Garcia administration will result in 10,000 new apartments ready for move-in in her fourth year. We assume that 60% of these apartments, or 6,000, will be occupied by a household who would otherwise be homeless or will be a direct placement from shelter. With an average household size of 2.2, that is 8,800 people impacted.',
      },
      {
        header: 'Increase eligibility for the right to counsel',
        text: 'Eighty-four percent of New Yorkers represented by a government-provided attorney avoided eviction and stayed in their homes according to the Community Service Society. Expanding eligibility for tenants making between 200%-400% of the Federal Poverty Line to have representation in eviction proceedings could serve another 55,000-70,000 households. If you take the low end of the estimate, research finds evictions increase the probability of filling out a shelter application by 16%, so the number of New Yorkers who avoid homelessness is ~4,300.',
        footnoteLink: 'https://www.cssny.org/news/entry/right-to-counsel-and-stronger-rent-laws-helped-reduce-evictions-in-2019#3, https://www.cssny.org/news/entry/nyc-right-to-counsel'
      },
      {
        header: 'Expand and simplify rental assistance programs',
        text: 'After a major New York State-subsidized rental assistance program ended in 2011, the number of New Yorkers entering shelter skyrocketed, climbing to a high of 39% above 2011 levels in 2018, with family homelessness rising to nearly 50% according to Coalition for the Homeless. Although the incremental rise in homelessness cannot exclusively be tied to this action, we assume we can reduce 15% of the current homelessness problem by shifting spending to rental assistance and paying rent arrears.',
        footnoteLink: 'https://www.coalitionforthehomeless.org/a-state-blueprint-for-ending-homelessness-what-governor-cuomo-must-do-to-help-end-new-yorks-homelessness-crisis/'   
      },
      {
        header: 'Raise the value of rental vouchers',
        text: 'Kathryn will make sure New Yorkers who are experiencing homelessness can actually rent an apartment with City and State housing vouchers. Right now, the value is too low - 11k New Yorkers living in shelters have a voucher. Kathryn will raise the value of City vouchers to match the value of federal Section 8 vouchers and work with the State to do the same. She will also aggressively enforce the law against landlords who are illegally discriminating against households with vouchers. Some households will still have difficulty finding an apartment due to household size and proximity to work or school, but if 25% of households were able to use their voucher, that would be another 2,750 New Yorkers who can leave shelter and get into permanent housing.',
        footnoteLink: 'https://gothamist.com/news/lawsuit-landlords-are-illegally-locking-out-thousands-of-homeless-new-yorkers'      
      },
      {
        header: 'Legalize single-room occupancy (SRO) housing',
        text: 'Smaller units are affordable and historically SROs were a source of cheap housing for New Yorkers. If we legalize SROs, we have another affordable option for New Yorkers. This assumes the City directly finances and puts income restrictions to create 500 units and that 35% of those units would go to New Yorkers who otherwise would have experienced homelessness. Over the long run, the zoning recommendations Kathryn will implement - legalizing SROs, ending apartment bans, and allowing basement apartments and accessory dwelling units - will increase the overall housing supply.',
        footnoteLink: 'https://furmancenter.org/files/NYUFurmanCenter_SRObrief_31JAN2018.pdf'      
      },
    ]
  },
  {
    name: 'Bringing back our small businesses',
    topic: 'Small Businesses',
    headerName: 'bring back small businesses',
    impactSummary: 'bring back 97% of small businesses',
    policyUnit: 'small businesses',
    policyUnitIsCurrency: false,
    policies: [
          {
        name: 'Cut red tape and create a single small business City permit',
        chartName: 'single permit',
        impact: 7500,
        description: 'Every day and every dollar counts for small businesses. A single small business City permit will help businesses reopen .'
      },
      {
        name: 'Extend credit to small businesses to reopen or stay open',
        chartName: 'loans',
        impact: 4000,
        description: 'Small business loans for entrepreneurs have a high impact on creating and restarting small businesses.'
      },
      {
        name: 'Expand access to benefits and savings accounts',
        chartName: 'expand benefits',
        impact: 10000,
        description: 'Starting a small business is risky. Expanding access to benefits for undocumented workers and freelancers reduces the risk.'
      },
      {
        name: 'Help childcare businesses reopen and expand',
        chartName: 'childcare',
        impact: 210,
        description: 'Offering free childcare for families making less than $70k will create new and bring back small childcare businesses.'
      },
      {
        name: 'Spend more City dollars at small businesses',
        chartName: 'small purchasing',
        impact: 9000,
        description: 'There are many qualified entrepreneurs in New York City who can (and do) fill our needs. Expanding our efforts to buy local and reach MWBEs encourages small business formation.'
      },
      {
        name: 'Fund parks, NYCHA, new healthcare centers, and infrastructure projects',
        chartName: 'infrastructure',
        impact: 1240,
        description: 'Most construction businesses are small businesses. Investing in parks, affordable housing, and other infrastructure will bring back small businesses.'
      },
    ],
    underChartText: 'New York City is missing 33k small businesses because of the pandemic. Kathryn will bring back 97% in her first term',
    details: [
      {
        header: 'Cut red tape and create a single small business City permit',
        text: 'Every dollar counts for small businesses across the City, especially before they generate revenue. Entry rates for small businesses have fallen by 15% in the last 20 years and making the permitting process easier and faster will help encourage a more dynamic economy that works for us all. Economists found that returning to entry costs from 20 years ago would raise capital by 7 percent. Multiplying the number of firms from 2018 by 7 percent translates into 7,500 small businesses.',
        footnoteLink: 'https://callumjones.github.io/files/entrycosts.pdf'     
      },
      {
        header: 'Extend credit to small businesses to reopen or stay open',
        text: 'Small business loans for new entrepreneurs have a high impact on creating new establishments. This is particularly important in communities that don’t have easy access to other sources of finance, such as lines of credit or loans from friends or family. A randomized control trial of microfinance in Union City, New Jersey found an increase in small business ownership of 20 percent. Our plan to offer 5000 business loans a year over four years leads to 4,000 new small businesses after adjusting for the 20 percent increase in small business ownership.',
        footnoteLink: 'https://www.mdrc.org/sites/default/files/Grameen_18_Mo_report-Final.pdf'
      },
      {
        header: 'Expand access to benefits and savings accounts',
        text: 'Starting a small business is risky, and for those locked out of the social safety net, it may be too much of a risk. Expanding access to benefits and savings accounts for freelancers and undocumented New Yorkers of working age will encourage entrepreneurship and the formation of small businesses throughout the City. We estimate there are approximately 1 million New Yorkers who would be impacted. In France, a study found that reforms like the one we are proposing led to a 10 percent increase in entrepreneurship. Our reform differs from the reforms adopted in France and we conservatively assume it will have a 1 percent impact of increasing entrepreneurship on the workers who will receive expanded benefits',
        footnoteLink: 'https://johanhombert.github.io/Hombert_2020JF_UIEntrepreneurs.pdf'
      },
      {
        header: 'Help childcare businesses reopen and expand',
        text: 'Based on the new demand for childcare due to our commitment to provide free childcare for families making less than $70,000 a year, approximately 1,260 direct childcare jobs are created. We assume that childcare businesses that start and re-open employ approximately six staff members that oversee 4-5 children each. This translates into approximately 210 small businesses.',
      },
      {
        header: 'Spend more City dollars at small businesses',
        text: 'Local procurement is great for small businesses and there are many qualified entrepreneurs in New York City who can (and do) fill the needs of the City. Expanding our efforts, including the City’s efforts to reach out to minority and women-owned business enterprises, keeps our tax dollars local and encourages business formation. In one study of local procurement, they found a 30 percent increase in the probability of participating in a future procurement. New York City spent around $200 million in micro and small procurements over 25,000 contracts. Increasing this by 30 percent would lead to an increase of 7,500 contracts each year. Assuming a 30 percent survival rate, over four years this policy will create 9,000 small businesses.',
        footnoteLink: 'https://www.nber.org/papers/w21219'
      },
      {
        header: 'Fund parks, NYCHA, new healthcare centers, and infrastructure projects',
        text: 'Most construction firms are small businesses and the investment Kathryn is making in housing and infrastructure will benefit these small business owners tremendously. We assume each $5 million in infrastructure spending translates into one contract and approximately one-third of those contracts are awarded to small businesses, consistent with research from the State of New York. Collectively, this policy will bring back 1,240 small businesses.',
        footnoteLink: 'https://www.osc.state.ny.us/files/reports/osdc/pdf/report-2-2020.pdf'
      }
    ]
  },
  {
    name: 'Saving the planet (and New York City) by reducing emissions',
    topic: 'Climate',
    headerName: 'save the planet (and New York City)',
    impactSummary: 'reduce emissions by 15 percentage points',
    policyUnit: '%',
    policyUnitIsCurrency: false,
    policies: [
      {
        name: 'Maximize renewable energy generation in and around NYC',
        chartName: 'renewable energy',
        impact: 5.6,
        description: 'Offshore wind, a Renewable Rikers Island, and ramping up distributed solar will generate an estimated 2,400 megawatts of energy, reducing emisions from 2005 levels by 5.6%.'
      },    
      {
        name: 'Build more transmission lines to bring in more renewable energy',
        chartName: 'new transmission',
        impact: 1.9,
        description: 'The City must build better transmission capacity for clean energy to flow from upstate New York and Canada to the five boroughs.'
      },    
      {
        name: 'Electrify heat and hot water in buildings',
        chartName: 'electrify buildings',
        impact: 4,
        description: 'Aggressively implementing Local Law 97, creating a carbon trading program, and decarbonizing NYCHA will reduce overall emissions by 4%.'
      },    
      {
        name: 'Green our buses, trucks, and private cars',
        chartName: 'green vehicles',
        impact: 0.9,
        description: 'Electric vehicles (EVs) have one-third the lifetime carbon intensity of conventional cars. Building out public and private EV infrastructure and replacing diesel and hybrid vehicles with EVs reduces emissions.'
      },    
      {
        name: 'Win the war against asphalt, invest in non-car transportation, and make freight more efficient',
        chartName: 'sustainable transportation',
        impact: 2.2,
        description: 'Congestion pricing, open streets, reduced truck traffic, and more bike and bus lanes will reduce car use and emissions.'
      },    
      {
        name: 'Execute our Zero Waste plan',
        chartName: 'zero waste',
        impact: 0.4,
        description: 'Prioritizing mandatory curbside composting and using food waste to power our green energy future can reduce our waste stream by 10%.'
      },    
    ],
    underChartText: 'New York City has already reduced emissions by 15% below 2005 levels and with our policies we can reduce emissions by another 50% within four years',
    details: [
      {
        header: 'Maximize renewable energy generation in and around NYC',
        text: 'New York State has a goal to generate 9,000 megawatts (MW) from offshore wind by 2035. If two-thirds of offshore wind energy goes to the New York City grid and 25 percent of offshore wind capacity is ready by 2025, 1,500 MW will be generated for New York City. Renewable Rikers could also generate 400 MW of combined solar and battery storage. Finally, cutting through red tape to make it easier to install solar will increase the total energy generated to 500 MW. In total, 2,400 MW will be generated, accounting for a 5.6 percent reduction based on current emissions levels.',
        footnoteLinks: [
          'https://www.greentechmedia.com/articles/read/new-yorks-new-green-push-includes-2.5gw-of-offshore-wind-contracts-for-equinor-and-bp',
          'https://www.nytimes.com/2019/11/15/nyregion/rikers-island-closing-future.html#:~:text=A%202017%20report%20by%20an,store%20an%20additional%20300%20megawatts.'
        ]
      },
      {
        header: 'Build more transmission lines to bring in more renewable energy',
        text: 'Cooperating with the state to build one transmission line that can bring in 1,000 MW of renewable energy is equivalent to replacing 1.07 MMt of CO2 or 1.9 percent.',
        footnoteLink: 'https://www.timesunion.com/news/article/Second-company-now-wants-to-build-a-power-line-in-15874286.php'
      },
      {
        header: 'Electrify heat andhot water in buildings',
        text: 'Buildings account for 40 percent of our greenhouse gase emissions. Local Law 97 requires certain buildings to reduce their emissions by 40 percent by 2030. By the end of Kathryn’s first term, we can get halfway to that goal assuming that the buildings that must comply with Local Law 97 account for half of all building emissions.',
      },
      {
        header: 'Green our buses, trucks, and private cars',
        text: 'Transportation accounts for 28.3 percent of greenhouse gas emissions. Because electrical vehicles are 66 percent less carbon-intense than comparable diesel vehicles, if our policies encourage a 5 percent increase in electric vehicles, we will reduce emissions by about 0.9 percent.',
        footnoteLink: 'https://nyc-ghg-inventory.cusp.nyu.edu/#data'
      },
      {
        header: 'Win the war against asphalt, invest in non-car transportation, and make freight more efficient',
        text: 'Passenger cars account for 22.6 percent of emissions. Our transportation policies can reduce passenger Vehicle Miles Traveled by 10%, resulting in a 2.2 percent decrease in emissions.',
      },
      {
        header: 'Execute our Zero Waste plan',
        text: 'Methane emissions from landfills and wastewater treatment account for 4 percent of our emissions. Creating an ambitious composting program and converting food waste into energy can reduce our waste stream by 10 percent by 2025. Reducing emissions that account for four percent of our greenhouse gases by 10 percent equals 0.4 percent.',
      }
    ]
  },
  {
    name: 'Keeping New Yorkers safe',
    topic: 'Public Safety',
    headerName: 'win the fucking world series',
    impactSummary: 'increase the number of home runs hit by 420%',
    policyUnit: 'home runs',
    policyUnitIsCurrency: false,
    policies: [],
    summaryBlockTooltip: 'Yankees rule, Mets drool',
    underChartText: 'Blah blah blah',
    details: []
  },
]



export default metrics.map(m => {

  const isReady = m.policies.length > 0;
  const slug = isReady ? encodeURIComponent( m.name.replaceAll(' ', '-').toLowerCase() ) : undefined;

  return {
    ...m,
    slug
  }
})

// {
//   name: 'Improving quality of life for NYCHA residents',
//   topic: 'Public Housing',
//   headerName: 'improve quality of life for NYCHA residents',
//   impactSummary: 'bring real improvements for nearly 70k residents',
//   policyUnit: 'residents',
//   policyUnitIsCurrency: false,
//   policies: [
//     {
//       name: 'Use federal Section 8 funding to completely renovate 20,400 apartments',
//       chartName: 'renovation',
//       impact: 44900,
//       description: 'Federal funding can provide a way to completely renovate NYCHA apartments, including using the Rental Assistance Demonstration (RAD) program. By focusing on implementation of these solutions, we can completely renovate 20,400 apartments that are home to 44,900 residents.'
//     },
//     {
//       name: 'Sell air rights to cover the cost of repairs and renovations',
//       chartName: 'air rights',
//       impact: 4800,
//       description: 'Selling air rights from NYCHA properties will bring in revenue to fund renovations and repairs.'
//     },
//     {
//       name: 'Residents with green jobs or infrastructure jobs',
//       chartName: 'green jobs',
//       impact: 19600,
//       description: 'Improvements to heating and cooling systems with climate-friendly alternatives will reduce outages and carbon emissions and create jobs. We will hire NYCHA residents to install green roofs and clean energy systems.'
//     },
//   ],
//   underChartText: 'Residents need results, not a plan. My approach will bring short-term rewsults for residents and safeguard NYCHA housing for the long-term',
//   details: []
// },
